export type BatchUploadPhase =
  'idle' | 'extracting' | 'validating' | 'ready' | 'uploading' | 'done';

export interface BatchUploadFlowState {
  phase: BatchUploadPhase;
  pendingCount: number;
  resultsCount: number;
  hasError?: boolean;
}

/** Map BatchUpload phase to a 1-based step index (5 = all done). */
export function batchUploadStep(s: BatchUploadFlowState): number {
  switch (s.phase) {
    case 'idle':
      return s.pendingCount > 0 ? 2 : 1;
    case 'extracting':
    case 'validating':
      return 2;
    case 'ready':
      return 3;
    case 'uploading':
      return 3;
    case 'done':
      return 5;
  }
}

/**
 * When the flow has an error, return the step that failed.
 * Otherwise return undefined.
 */
export function batchUploadErrorStep(
  s: BatchUploadFlowState,
): number | undefined {
  if (!s.hasError) {
    return undefined;
  }
  // idle with no pending = the user got an extraction error on the very first step
  if (s.phase === 'idle') {
    return s.pendingCount > 0 ? 2 : 1;
  }
  // ready with error = upload failed (we reset to ready after upload error)
  if (s.phase === 'ready') {
    return 3;
  }
  return batchUploadStep(s);
}
